"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORDS_DEFAULT_LIMIT = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const TGLazyModalWeb_1 = __importDefault(require("../TGLazyModalWeb"));
const TGOptionLazyModalActionsWeb_1 = __importDefault(require("./TGOptionLazyModalActionsWeb"));
const TGOptionModalRowRendererWeb_1 = __importStar(require("./TGOptionModalRowRendererWeb"));
exports.RECORDS_DEFAULT_LIMIT = 100;
const TGOptionLazyModalWeb = (props) => {
    const { data, value, multiSelect, pathToValue, pathToLabel, searchText, refetch, setOpen, onDone, setSelectedOptions, translateFunction = text => text } = props, moreProps = __rest(props, ["data", "value", "multiSelect", "pathToValue", "pathToLabel", "searchText", "refetch", "setOpen", "onDone", "setSelectedOptions", "translateFunction"]);
    const [state, setState] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        setState(prev => (prev.length === 0 && value.length > 0 ? value : prev));
    }, [value]);
    const setStateWrapper = (0, react_1.useCallback)((newState) => {
        setState(newState);
        if (!multiSelect) {
            setTimeout(() => {
                setOpen(false);
                onDone(newState);
            });
        }
    }, [setOpen, multiSelect, onDone]);
    (0, react_1.useEffect)(() => {
        setSelectedOptions([...state]);
    }, [state]);
    const [listDataKey, setListDataKey] = (0, react_1.useState)(0);
    const refresh = (0, react_1.useCallback)(() => setListDataKey(prev => prev + 1), []);
    const handleDone = () => {
        onDone(state);
    };
    const isNothingSelected = state.length === 0;
    const handleClearAll = () => {
        setStateWrapper([]);
        refresh();
    };
    const generalRowRendererProps = (0, react_1.useMemo)(() => ({
        multiSelect: !!multiSelect,
        pathToValue,
        pathToLabel,
    }), [multiSelect, pathToValue, pathToLabel]);
    const selectAllAssets = (0, react_1.useCallback)(() => {
        refetch(true, data => {
            setStateWrapper([...data]);
        });
    }, [refetch, setStateWrapper]);
    return (react_1.default.createElement(TGLazyModalWeb_1.default, Object.assign({}, props, { state: state, setState: setStateWrapper, actions: react_1.default.createElement(TGOptionLazyModalActionsWeb_1.default, { state: state, totalCount: props.totalCount, multiSelect: !!multiSelect, isNothingSelected: isNothingSelected, handleClearAll: handleClearAll, selectAllAssets: selectAllAssets, translateFunction: translateFunction }), rowRenderer: TGOptionModalRowRendererWeb_1.default, rowRendererProps: generalRowRendererProps, listDataKey: listDataKey, onDone: multiSelect ? handleDone : undefined, rowHeight: TGOptionModalRowRendererWeb_1.ROW_HEIGHT_WEB, searchText: searchText, handleSearchText: props.handleSearchText, data: data, fetchMoreData: props.fetchMoreData, loading: props.loading, error: props.error, isAllLoaded: props.isAllLoaded, translateFunction: translateFunction })));
};
exports.default = TGOptionLazyModalWeb;
//# sourceMappingURL=TGOptionLazyModalWeb.js.map